import { InsuranceCompany, InsuranceCompanyEnum } from '../../model/InsuranceCompany';
import { PatientInfoDtoInInsuranceCompanyEnum } from '../../generated';

export const fromInsuranceCompanyToGenerated = (data?: InsuranceCompany): PatientInfoDtoInInsuranceCompanyEnum => {
  switch (data?.code) {
    case (InsuranceCompanyEnum.Vzp):
      return PatientInfoDtoInInsuranceCompanyEnum.Vzp;
    case (InsuranceCompanyEnum.Vozp):
      return PatientInfoDtoInInsuranceCompanyEnum.Vozp;
    case (InsuranceCompanyEnum.Cpzp):
      return PatientInfoDtoInInsuranceCompanyEnum.Cpzp;
    case (InsuranceCompanyEnum.Ozp):
      return PatientInfoDtoInInsuranceCompanyEnum.Ozp;
    case (InsuranceCompanyEnum.Zps):
      return PatientInfoDtoInInsuranceCompanyEnum.Zps;
    case (InsuranceCompanyEnum.Zpmv):
      return PatientInfoDtoInInsuranceCompanyEnum.Zpmv;
    case (InsuranceCompanyEnum.Rbp):
      return PatientInfoDtoInInsuranceCompanyEnum.Rbp;
    case (InsuranceCompanyEnum.Other):
      return PatientInfoDtoInInsuranceCompanyEnum.Other;
    default:
      throw new Error(`Insurance company ${data} is not supported.`);
  }
};
